<div [class]="visible ? 'flex flex-col h-full' : 'hidden'">
  <div class="h-full flex flex-col gap-3">
    <!-- Consolidation Loading Indicator -->
    <div *ngIf="consolidationLoading"
      class="flex items-center gap-2 px-3 py-2 bg-blue-100 border border-blue-400 rounded-md">
      <i class="pi pi-spin pi-spinner text-blue-600 text-xl"></i>
      <span class="text-blue-700 font-semibold">Scanning for inactive product configurations...</span>
    </div>

    <p-splitter class="grow w-full" layout="vertical" styleClass="h-full" [panelSizes]="[60, 40]">
      <ng-template pTemplate>
        <div class="h-full w-full flex flex-col">
          <div class="flex flex-row gap-3 mb-4">
            <p-button [disabled]="parent.isReadOnly()" (click)="onPptcAdd()" label="Attach Product Types"
              icon="pi pi-plus" size="small"></p-button>
            <div class="mt-2">
              <p-checkbox [(ngModel)]="shouldShowOnlyProductsWithNoTags" (onChange)="refreshPptcs()" [binary]="true"
                name="shouldShowOnlyProductsWithNoTags" inputId="shouldShowOnlyProductsWithNoTags"
                class="mt-1"></p-checkbox>
              <label for="shouldShowOnlyProductsWithNoTags" class="ml-2 mt-1">Show Only Products with No Tags</label>
            </div>
          </div>
          <div class="grow">
            <prox-ag-grid gridId="productsGrid" [gridOptions]="pptcGridOptions" [rowData]="pptcs"></prox-ag-grid>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate>
        <p-splitter [panelSizes]="[50, 50]" class="w-full" styleClass="h-full">
          <ng-template pTemplate>
            <div class="grow">
              <prox-ag-grid [gridOptions]="ptcpGridOptions" [rowData]="ptcps"
                [hasColSizeButtons]="false"></prox-ag-grid>
            </div>
          </ng-template>
          <ng-template pTemplate>
            <div class="grow">
              <prox-ag-grid [gridOptions]="ptcaGridOptions" [rowData]="ptcas"
                [hasColSizeButtons]="false"></prox-ag-grid>
            </div>
          </ng-template>
        </p-splitter>
      </ng-template>
    </p-splitter>
  </div>
</div>